import React, { Fragment } from "react";
import { FormikContextType, FormikProvider } from "formik";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { I18nTranslator, translations } from "utils/i18n";
import Add from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import { RoleHelper } from "helpers";
interface IFormContainer {
  title?: string;
  formik: FormikContextType<any>;
  loading: boolean;
  isAdd?: boolean;
  onDelete?(): void;
  renderButtons?: React.ReactNode;
  renderConfirmButton?: React.ReactNode;
  disableSubmit?: boolean;
  disableDelete?: boolean;
  confirmButtonTitle?: string;
  saveButtonTitle?: string;
  saveButtonIcon?: React.ReactNode;
  hideDefaultSaveButton?: boolean;
  hideDefaultConfirmButton?: boolean;
}

const FormContainer: React.FC<IFormContainer> = (props) => {
  const {
    title,
    formik,
    loading,
    isAdd,
    onDelete,
    renderButtons,
    renderConfirmButton,
    disableSubmit,
    disableDelete,
    children,
    confirmButtonTitle,
    saveButtonTitle,
    saveButtonIcon,
    hideDefaultSaveButton,
    hideDefaultConfirmButton,
  } = props;
  return (
    <Box sx={{ bgcolor: "white", width: "100%" }}>
      <FormikProvider value={formik}>
        <form noValidate onSubmit={formik.handleSubmit}>
          <Stack>
            <Typography variant="h2">{title}</Typography>
            <Box sx={{ py: 2 }}>{children}</Box>
            <Footer
              formik={formik}
              loading={loading}
              isAdd={isAdd}
              onDelete={onDelete}
              renderConfirmButton={renderConfirmButton}
              renderButtons={renderButtons}
              disableSubmit={disableSubmit}
              disableDelete={disableDelete}
              confirmButtonTitle={confirmButtonTitle}
              saveButtonTitle={saveButtonTitle}
              saveButtonIcon={saveButtonIcon}
              hideDefaultSaveButton={hideDefaultSaveButton}
              hideDefaultConfirmButton={hideDefaultConfirmButton}
            />
          </Stack>
        </form>
      </FormikProvider>
    </Box>
  );
};

const Footer = (props: {
  formik: FormikContextType<any>;
  loading: boolean;
  isAdd?: boolean;
  onDelete?(): void;
  renderButtons?: React.ReactNode;
  renderConfirmButton?: React.ReactNode;
  disableSubmit?: boolean;
  disableDelete?: boolean;
  confirmButtonTitle?: string;
  saveButtonTitle?: string;
  saveButtonIcon?: React.ReactNode;
  hideDefaultSaveButton?: boolean;
  hideDefaultConfirmButton?: boolean;
}) => {
  return (
    <Box>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="flex-end"
        spacing={2}
      >
        {props.renderButtons}
        {props.isAdd ? (
          !props.hideDefaultConfirmButton && (
            <Grid item>
              {props.renderConfirmButton || (
                <LoadingButton
                  variant="contained"
                  type="submit"
                  color="primary"
                  loading={props.loading}
                  startIcon={<Add />}
                  disabled={props.disableSubmit || !RoleHelper.isSuperAdmin()}
                >
                  {props.confirmButtonTitle ||
                    I18nTranslator(translations.button.create)}
                </LoadingButton>
              )}
            </Grid>
          )
        ) : (
          <Fragment>
            {props.onDelete && (
              <Grid item>
                <Button
                  variant="contained"
                  color="error"
                  onClick={props.onDelete}
                  startIcon={<DeleteIcon />}
                  disabled={
                    props.disableDelete !== undefined
                      ? props.disableDelete
                      : !RoleHelper.isSuperAdmin() && !RoleHelper.isSupervisor()
                  }
                >
                  {I18nTranslator(translations.button.delete)}
                </Button>
              </Grid>
            )}
            {!props.hideDefaultSaveButton && (
              <Grid item>
                <LoadingButton
                  variant="contained"
                  type={"submit"}
                  loading={props.loading}
                  startIcon={props.saveButtonIcon || <SaveIcon />}
                  disabled={
                    props.disableSubmit !== undefined
                      ? props.disableSubmit
                      : !RoleHelper.isSuperAdmin() && !RoleHelper.isSupervisor()
                  }
                >
                  {props.saveButtonTitle ||
                    I18nTranslator(translations.button.save)}
                </LoadingButton>
              </Grid>
            )}
          </Fragment>
        )}
      </Grid>
    </Box>
  );
};

export default FormContainer;
